document.addEventListener('DOMContentLoaded', function () {
  // モバイル表示かどうかをチェック
  function isMobile() {
    return window.innerWidth <= 749;
  }

  // Intersection Observerの設定
  const options = {
    root: null, // ビューポートをルートとして使用
    rootMargin: '-100px 0px 0px 0px',
    threshold: 0.5, // 要素の50%が表示されたときに実行
  };

  // 表示アニメーション対象の要素を監視
  const animateElements = document.querySelectorAll('.c_js-sp-fadein');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && isMobile()) {
        // モバイル表示時のみ処理を実行
        // 要素を表示
        entry.target.classList.add('is-visible');

        // 一度表示されたら監視を解除
        observer.unobserve(entry.target);
      }
    });
  }, options);

  // 各アニメーション対象要素を監視対象に追加
  animateElements.forEach((element) => {
    observer.observe(element);
  });

  // ウィンドウサイズが変更された場合、監視を再設定
  window.addEventListener('resize', function () {
    // 監視を一度解除
    animateElements.forEach((element) => {
      observer.unobserve(element);
    });

    // 再度監視を設定
    animateElements.forEach((element) => {
      observer.observe(element);
    });
  });
});

// 横スクロールバー常時表示
function initializeFakeScroll(wrapper) {
  const scrollContainer = wrapper.querySelector('.scroll-container');
  const fakeScrollbar = wrapper.querySelector('.fake-scrollbar');
  const fakeThumb = wrapper.querySelector('.fake-thumb');
  
  if (!scrollContainer || !fakeScrollbar || !fakeThumb) return;

  let isDragging = false;
  let dragStartX = 0;
  let thumbStartLeft = 0;
  let scrollbarWidth = 0;

  function updateThumb() {
    const containerWidth = scrollContainer.clientWidth;
    const contentWidth = scrollContainer.scrollWidth;
    const scrollLeft = scrollContainer.scrollLeft;
    
    scrollbarWidth = fakeScrollbar.clientWidth;
    let thumbWidth = (containerWidth / contentWidth) * scrollbarWidth;
    fakeThumb.style.width = `${thumbWidth}px`;
    
    const thumbLeft = scrollLeft / (contentWidth - containerWidth) * (scrollbarWidth - thumbWidth);
    fakeThumb.style.left = `${thumbLeft}px`;
  }

  function startDrag(e) {
    isDragging = true;
    dragStartX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
    thumbStartLeft = parseInt(window.getComputedStyle(fakeThumb).left, 10);
    e.preventDefault();
  }

  function onDrag(e) {
    if (!isDragging) return;
    
    const clientX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
    const deltaX = clientX - dragStartX;
    const newLeft = Math.min(Math.max(thumbStartLeft + deltaX, 0), scrollbarWidth - fakeThumb.clientWidth);
    
    fakeThumb.style.left = `${newLeft}px`;
    
    const scrollRatio = newLeft / (scrollbarWidth - fakeThumb.clientWidth);
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    scrollContainer.scrollLeft = scrollRatio * maxScroll;
  }

  function endDrag() {
    isDragging = false;
  }

  function jumpToClick(e) {
    if (e.target !== fakeScrollbar) return;
    const clickX = e.clientX - fakeScrollbar.getBoundingClientRect().left;
    const thumbCenter = fakeThumb.clientWidth / 2;
    const newLeft = Math.min(Math.max(clickX - thumbCenter, 0), scrollbarWidth - fakeThumb.clientWidth);
    
    fakeThumb.style.left = `${newLeft}px`;
    
    const scrollRatio = newLeft / (scrollbarWidth - fakeThumb.clientWidth);
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    scrollContainer.scrollLeft = scrollRatio * maxScroll;
  }

  // イベント設定
  scrollContainer.addEventListener('scroll', updateThumb);
  window.addEventListener('resize', updateThumb);

  fakeThumb.addEventListener('mousedown', startDrag);
  fakeScrollbar.addEventListener('mousedown', jumpToClick);
  document.addEventListener('mousemove', onDrag);
  document.addEventListener('mouseup', endDrag);

  fakeThumb.addEventListener('touchstart', startDrag);
  fakeScrollbar.addEventListener('touchstart', jumpToClick);
  document.addEventListener('touchmove', onDrag);
  document.addEventListener('touchend', endDrag);

  // 初期設定
  updateThumb();
}

// 最初にある分だけセット
document.querySelectorAll('.scroll-wrapper').forEach(wrapper => {
  initializeFakeScroll(wrapper);
});

// あとから追加されたらセット
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) { // 要素ノード
        if (node.classList.contains('scroll-wrapper')) {
          initializeFakeScroll(node);
        }
        // deeperに子孫に含まれてる場合にも対応
        node.querySelectorAll && node.querySelectorAll('.scroll-wrapper').forEach(inner => {
          initializeFakeScroll(inner);
        });
      }
    });
  });
});

// ページ全体を監視
observer.observe(document.body, {
  childList: true,
  subtree: true
});
